import { Component } from "react";

const title = "Join The Cute Monster";
const desc = "Join a genuine community of 150,000 Cute Monster!";
const btnText = "Join Our Discord";

class Community extends Component {
    render() { 
        return (
            <section className="community padding-top padding-bottom bg__primary">
                <div className="container">
                    <div className="community__wrapper" data-aos="zoom-in" data-aos-duration="1000">
                        <div className="community__content text-center">
                            <h2>{title}</h2>
                            <p>{desc}</p>
                            <a href="#" className="default-btn default-btn--rounded"><span>{btnText}</span></a>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default Community;